<h1 *ngIf="data.product; else imgTitle" mat-dialog-title>Item added to basket</h1>
<ng-template #imgTitle><h1 mat-dialog-title> Detail view </h1></ng-template>

<div mat-dialog-content>
  <p *ngIf="data.product; else imgBig">{{data.product}} has been added to your basket.</p>
  <ng-template #imgBig><img class="bigImg" src="{{data.image}}"></ng-template>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close] cdkFocusInitial>Ok</button>
</div>
